module.exports = __webpack_public_path__ + "img/download-ios@2x.fad105ce.png";